import * as queries from './graphql-queries';
import { get, post, put, del } from '../../../utils/http';
import Promise from 'bluebird';
import checkStatus from '../../../utils/checkStatus.js';
import { callApiJWT } from '../../../api';
import R from 'ramda';

import { checkLocAccess, triggerNoAccessWarning } from '../../../middleware/accessCheckHelperFns';
import { replace } from 'react-router-redux';

export const toggleDraftErrorsDialog = () => ({ type: 'TOGGLE_DRAFT_ERRORS_DIALOG' });
export const toggleShowChangesPopover = (open, event) => ({ type: 'TOGGLE_SHOW_DRAFT_CHANGES_POPOVER', payload: { anchorEl: event.currentTarget, open, } });

export const addFileToContractInDB = (contractId, files) => dispatch => {
  dispatch({ type: 'ADD_CONTRACT_FILES', payload: { files: files.map(o => ({ ...o, source: 'directUpload' })) } });
  return post('/proxy/contracting/contract/files', { contractId, files })
  .then(checkStatus)
  .then(res => res.json())
  .then(filesSaved => {
    dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
    return filesSaved;
  });
};

export const linkToContractFromHistoryFeedId = (payload) => ({ type: 'CONTRACT_FROM_HF', payload });

export const addFileToContractFromMessage = (messageId, files) => (dispatch, getState) => {
  const leftNav = getState().contracting.contractActivitiesProducts.get('leftNav').toJS();
  const contractId = leftNav.contractId;
  return post('/proxy/contracting/contract/files', { contractId, messageId, files })
  .then(checkStatus)
  .then(res => res.json())
  .then(() => {
    dispatch(getHistoryFeeds('contract', contractId));
    dispatch(getContractLeftNav('contract', contractId, true));
  });
};

export const deleteFileFromContractInDB = (contractId, fileId) => dispatch => {
  return del('/proxy/contracting/contract/file', { contractId, fileId })
  .then(checkStatus)
  .then(res => res.json())
  .then(filesSaved => {
    dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
  });
};
export const modifyFileFromContractInDB = (contractId, fileId, updater) => dispatch => {
  return put('/proxy/contracting/contract/file', { contractId, fileId, updater })
  .then(checkStatus)
  .then(res => res.json())
  .then((filesSaved) => {
    dispatch({ type: 'CONTRACT_FILES_MODIFIED', payload: { files: filesSaved } });
  });
};
export function createDraft(contractId, templateId, templateEdit) {
  return post(`/proxy/contracting/draft/${contractId}`, {
    templateId,
    templateEdit,
  })
  .then(checkStatus)
  .then(res => res.json());
}

export function clearStore() {
  return { type: 'CLEAR_CONTRACT_ACTIVITY_PRODUCT_REDUCER' };
}
const catchLoadContentError = R.curry((dispatch, collection, err) => {
  console.log(err);
  dispatch({
    type: 'GET_CONTRACT_INFO_ERROR',
    payload: {
      errorOccurs: R.call(R.cond([
        [
          () => (err.message || '').toLowerCase() === 'not found',
          () => {
            if (window.location.href.indexOf(process.env.SECONDARY_SYSTEM_URL) > -1) {
              return `In order to protect the security and integrity of rate data, you can only have one rate sheet open at a time.`;
            }
            return `${collection === 'draft' ? 'This draft no longer exists.' : 'This document does not exist.'}`;
          },
        ],
        [() => err.message === 'Forbidden', R.always(`You don't have permission to view this document.`)],
        [R.T, R.always('An Error Occurred')],
      ])),
    },
  });
});
export const getContractLeftNav = (collection, contractId, backgroundRefresh) => (dispatch, getState) => {
  if (!backgroundRefresh) dispatch({ type: 'CONTRACT_LEFT_NAV_LOADING' });
  if (collection === 'draft') dispatch(checkContractReadiness(contractId));
  return callApiJWT(`/contracting/getContractInfo/${contractId}`, 'post', {
    query: collection === 'contract' || collection === 'workspace' ? queries.getLeftNavQuery : queries.draftTemplateLeftNav,
    contractId,
    collection: collection === 'workspace' ? 'contract' : collection,
  })
  .then(({ response: res }) => {
    dispatch({ type: 'GET_CONTRACT_LEFT_NAV', payload: { ...res, contractId, collection, [`${contractId}Loaded`]: true } });
    return { payload: { ...res, contractId, collection, [`${contractId}Loaded`]: true } };
  })
  .catch(catchLoadContentError(dispatch, collection));
};

export const getContractDetails = (collection, contractId, backgroundRefresh) => (dispatch, getState) => {
  if (!backgroundRefresh) dispatch({ type: 'CONTRACT_CONTENT_LOADING' });
  return callApiJWT(`/contracting/getContractInfo/${contractId}`, 'post', {
    query: collection === 'contract' || collection === 'workspace' ? queries.getContractDetailsQuery : queries.draftTemplateContractDetails,
    contractId,
    collection: collection === 'workspace' ? 'contract' : collection,
  })
  .then(({ response: res }) => {
    dispatch({ type: 'GET_CONTRACT_DETAILS', payload: { ...res, contractId, collection, [`${contractId}Loaded`]: true } });
  })
  .catch(catchLoadContentError(dispatch, collection));
};
export function openImportFromOtherProductsDialog(noShowIfEmpty) {
  return (dispatch, getState) => {
    return dispatch({
      type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload: {
        type: 'copyDataFromAnotherProduct',
        title: 'Copy data from another product',
        data: {
          noShowIfEmpty,
        },
      },
    });
  };
}
export const getProductDetails = (collection, contractId, productId, ratePackage, backgroundRefresh) => (dispatch, getState) => {
  if (!productId || productId === 'undefined') return dispatch({ type: 'GET_PRODUCT_DETAILS', payload: { product: {} } });
  if (!backgroundRefresh) dispatch({ type: 'CONTRACT_CONTENT_LOADING' });
  return callApiJWT(`/contracting/getProductInfo/${contractId}/${productId}/${ratePackage}`, 'post', {
    query: collection === 'contract' ? queries.getProductDetailsQuery : queries.draftTemplateProductQuery,
    contractId,
    productId,
    collection,
  })
  .then(({ response: res }) => {
    return dispatch({ type: 'GET_PRODUCT_DETAILS', payload: {
      ...res,
      contractId,
      collection,
      product: { ...res.product, [`${contractId}Loaded`]: true } },
    });
  })
  // .catch(catchLoadContentError(dispatch, collection));
};

export const reloadContentInBg = ({ collection, contractId, productId, ratePackage }) => dispatch => {
  dispatch(getContractLeftNav(collection, contractId, true));
  if (productId) dispatch(getProductDetails(collection, contractId, productId, ratePackage, true));
  else dispatch(getContractDetails(collection, contractId, true));
};

export const getHistoryFeeds = (collection, contractId) => (dispatch, getState) => {
  dispatch({ type: 'LOADING_HISTORY_FEEDS' });
  return callApiJWT(`/contracting/getHistoryFeed/${contractId}/${collection}`, 'get')
  .then(({ response }) => {
    return dispatch({ type: 'GET_HISTORY_FEEDS', payload: { response, contractId } });
  });
};

export const deleteProductFromContract = payload => (dispatch, getState) => {
  const locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
  const hasAccess = checkLocAccess(getState(), locationId, 'contracting', 'write');
  if (!hasAccess) return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));

  const composedUrl = `/proxy/contracting/deleteProductFromContract`;
  const onOk = () => {
    dispatch({ type: 'DELETE_PRODUCT_FROM_CONTRACT_START' });
    return del(composedUrl, payload)
    .then(checkStatus)
    .then(res => res.json())
    .then(response => {
      dispatch(getContractLeftNav('draft', payload.contractId));
      return dispatch({ type: 'DELETE_PRODUCT_FROM_CONTRACT', payload: { ...payload, ...response } });
    })
    .catch((err) => console.log(err.stack));
  };
  dispatch({ type: 'open_global_alert', payload: {
    text: `Are you sure you want to remove this product from this contract?`,
    onOk,
  } });
};
export function updatePartnerForSentDoc() {
  return { type: 'UPDATE_CONTRACT_PARTNER_INFO' };
}
export function doResendContract() {
  return (dispatch, getState) => {
    const {
      contractId,
      customizedMessage,
      resendToEmails,
      newRecipients = [],
      partner,
      subject,
      deadlineDate,
    } = getState().contracting.resendContractDialog.toJS();
    dispatch({ type: 'RESEND_CONTRACT_STARTING', payload: true });
    return fetch(`/proxy/contracting/resendContract/${contractId}`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        deadlineDate,
        customizedMessage,
        resendToEmails,
        newRecipients: newRecipients
          .filter(obj => obj.email && obj.email.trim())
          .map(obj => ({ ...obj, email: obj.email.trim().toLowerCase() })),
        partner,
        subject,
      }),
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      if (newRecipients && newRecipients.length) reloadContentInBg({ collection: 'contract', contractId })(dispatch);
      return dispatch({ type: 'RESEND_CONTRACT_FINISHED' });
    });
  };
}

export const downloadContractPdf = (contractId, state, anchorEl) => dispatch => {
  return dispatch({
    type: '[contracting-download]OPEN_DOWNLOAD_CONTRACTING_DOCS_POPOVER',
    payload: {
      docId: contractId,
      collection: R.call(R.cond([
        [R.isNil, R.always('template')],
        [R.equals('publish-ready'), R.always('draft')],
        [R.equals('draft'), R.always('draft')],
        [R.equals('template'), R.always('template')],
        [R.T, R.always('contract')],
      ]), state),
      anchorEl,
    },
  });
};

export const discardEditedDraft = (contractId) => (dispatch, getState) => {
  const locationId = getState().contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']);
  const hasAccess = checkLocAccess(getState(), locationId, 'contracting', 'write');
  if (!hasAccess) return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));

  const confirmed = window.confirm('Are you sure you want to discard all changes you made with this draft?');
  if (confirmed) {
    dispatch({ type: 'DISCARD_EDITED_CONTRACT_DRAFT_STARTING', payload: { contractId } });
    return fetch(`/proxy/contracting/discardEditedDraft/${contractId}`, {
      method: 'delete',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return Promise.resolve({});
    })
    .then(() => {
      dispatch(replace(`/contracting/template/${contractId}/details`));
    })
    .catch(err => dispatch({ type: 'DISCARD_EDITED_CONTRACT_DRAFT_FAILED', payload: { contractId } }));
  }
}

export function sortingProducts(contractId, products) {
  return (dispatch, getState) => {
    return fetch(`/proxy/contracting/sortingProducts`, {
      method: 'put',
      credentials: 'same-origin',
      body: JSON.stringify({
        contractId,
        products,
      }),
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
      .then(res => {
        if (res.status !== 200) throw new Error(res.status);
        const productId = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'productId']);
        const ratePackage = getState().contracting.contractActivitiesProducts.getIn(['rightSideContent', 'ratePackageName']) || 'Primary';
        reloadContentInBg({ collection: 'draft', contractId, productId, ratePackage })(dispatch);
        return dispatch({ type: 'PRODUCTS_SORTED_IN_CONTRACT', payload: { contractId, products } });
      });
  };
}

export function checkContractReadiness(draftId) {
  const composedUrl = `/contracting/checkContractReadiness/${draftId}`;
  return dispatch => {
    return callApiJWT(composedUrl, 'put')
    .then(({ response }) => {
      dispatch({ type: '[template-draft]CHECK_COMPLETENESS_FOR_TEMPLATE_DRAFT', payload: { errors: response.errors } });
    });
  };
}

export const onCheckSyncSection = (sectionInEdit, checked) => ({ type: 'ON_CHECK_SYNC_SECTION_IN_CONTRACT_TEMPLATE_DRAFT', payload: { sectionInEdit, checked } });




// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/contract-activities-products-actions.js